/**
 * This code was generated by Builder.io.
 */
import React from "react";
import Logo from "./Logo";

const Footer = () => {
  const quickLinks = [
    { title: "About Us", link: "/about" },
    { title: "Services", link: "/services" },
    { title: "FAQs", link: "/faq" },
    { title: "Blogs", link: "/blog" },
    { title: "Contact Us", link: "/contact" },
  ];
  const contactInfo = [
    { label: "Phone number:", value: "07040000014" },
    { label: "Email Address:", value: "info@orbitfinancial.ng" },
    { label: "Office Location:", value: "Orbit Financial Services Ltd Plot 1062 Abagbon Close, Victoria Island, Lagos" }
  ];
  const socialIcons = [
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/5016c179157fffa49eb37c28d06331656b6c16f06b44d92763fad6affcca08fb?apiKey=0dc91187d1fc4cb3931d3d7b27a4a892&",
      alt: "Facebook",
      link: "https://www.facebook.com/share/1B6gh2XtZX/?mibextid=wwXIfr",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/0d46c525aeaa42cbe298b32ad6b0e658d524d576bad17a423a7eb79a98616b0f?apiKey=0dc91187d1fc4cb3931d3d7b27a4a892&",
      alt: "Twitter",
      link: "https://x.com/orbitfinancial_?s=21&t=rw9hvtVHbEjoICem_BUesA",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/51e1fd097e6005111ac1800ba3e984f2efb782bda8ed2133df151e6ac2caa881?apiKey=0dc91187d1fc4cb3931d3d7b27a4a892&",
      alt: "Instagram",
      link: "https://www.instagram.com/orbitfinancialgroup?igsh=MWRsM3doaWt5eGI1dw==",
    },
    {
      src: "https://cdn.builder.io/api/v1/image/assets/TEMP/b306f1f92ccf93038b2944e429baaa93296ad05a9d5ccb60eb49acdef6a304eb?apiKey=0dc91187d1fc4cb3931d3d7b27a4a892&",
      alt: "LinkedIn",
      link: "https://www.linkedin.com/company/orbit-financial-services-limited",
    },
  ];

  return (
    <footer className="footer">
      <style jsx>{`
        .contact-label {
          font-weight: bold;
          color: #333;
        }
        .contact-value {
          font-weight: normal;
          color: #666;
        }
      `}</style>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <Logo />
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-list">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.link} className="footer-link">
                      {link.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Contact Information</h4>
              <ul className="footer-list">
                {contactInfo.map((info, index) => (
                  <li key={index} className="footer-info">
                    <span className="contact-label">{info.label}</span>{' '}
                    <span className="contact-value">{info.value}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-column">
              <h4 className="footer-heading">Follow us</h4>
              <div className="social-icons">
                {socialIcons.map((icon, index) => (
                  <a key={index} href={icon.link} target="_blank" className="social-link">
                    <img
                      loading="lazy"
                      src={icon.src}
                      alt={icon.alt}
                      className="social-icon"
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-legal">
            <a href="#" className="legal-link">
              Terms of Service
            </a>
            <a href="#" className="legal-link">
              Privacy Policy
            </a>
          </div>
          <p className="copyright">
            © Copyright 2025 Orbit All rights reserved. Crafted by Codakraft
            Tech.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
